fragment Newsletter on newsletterBlockBlock_Entry {
    title: blockTitle
    listId
    consentId
    backgroundColor
    customBackgroundColor
    image {
        url
        w1260: url @transform(format: "webp", width: 1260)
        w1260_avif: url @transform(format: "avif", width: 1260)
        w660: url @transform(format: "webp", width: 660)
        w660_avif: url @transform(format: "avif", width: 660)
        w480: url @transform(format: "webp", width: 480)
        w480_avif: url @transform(format: "avif", width: 480)
        w320: url @transform(format: "webp", width: 320)
        w320_avif: url @transform(format: "avif", width: 320)
    }
    description
}
